export default [
  {
    path: "/mahasiswa",
    component: () => import("@/pages/mahasiswa/mahasiswa-list.vue"),
    meta: {
      requiredLevel: ["admin", "verificator"],
    },
  },
  {
    path: "/mahasiswa/detail/:id",
    component: () => import("@/pages/mahasiswa/mahasiswa-detail.vue"),
    meta: {
      requiredLevel: ["admin", "verificator"],
    },
  },
  {
    path: "/verifikasi",
    component: () => import("@/pages/verifikasi/list-page.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/verifikasi/create",
    component: () => import("@/pages/verifikasi/create-page.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/verifikasi/update/:id",
    component: () => import("@/pages/verifikasi/update-page.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
];
